import {
  useNatively as useNativelyClient,
  Natively,
  NativelyInfo,
  NativelyContacts
} from "natively/dist";

type UseNatively = {
  natively: Natively;
  isNativeApp: boolean;
  nativelyInfo: NativelyInfo;
  nativelyContacts: NativelyContacts;
};

export function useNatively(): UseNatively {
  const natively = useNativelyClient();

  const nativelyInfo = new NativelyInfo();
  const nativelyContacts = new NativelyContacts();

  const { isNativeApp } = nativelyInfo.browserInfo();

  return { natively, nativelyInfo, nativelyContacts, isNativeApp };
}
